import request from '@/common/request.js'

export function sendMsgCode (data) {
  return request.get('/anonymous/auth/sendMsgCode', { params: data })
}

